





















































































































































import Vue from 'vue';

interface Info {
  id: string;
  currency: string;
  priceInCents: number;
  installments: number;
  productName: string;
  studentId: string;
  studentName: string;
  projectId: string;
  projectName: string;
  agreementFileName: string;
  agreementLink: string;
  delinquencyStatus: string;
  agency: string;
  sentAt: Date;
  archivedAt: Date;
  status: string;
  loanBalanceInDollars: string;
  origin: 'ppm' | 'lnpl';
}

interface PaymentDetails {
  card?: {
    type: 'credit' | 'debit' ;
    brand: string;
    lastFourDigits: string;
    expirationMonth: string;
    expirationYear: string;
  };
  bank?: {
    accountType: string;
    lastFiveDigitsAccountNumber: string;
    lastFiveDigitsRoutingNumber: string;
  };
}

export default Vue.extend({
  props: {
    orderInfo: {
      type: Object,
      default: () => ({} as Partial<Info>),
    },
    paymentDetails: {
      type: Object,
      default: () => ({} as Partial<PaymentDetails>),
    },
  },
});
